<div class="stk-table-loader add-segment-loader" *ngIf="lobLoader">
  <app-loader>
  </app-loader>
</div> 
  <div class="row-new lob-edit-first">
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
      <div class="form-group ">
        <span class="opid form-inline" for="groupname">
          <p style="color: #013b71;font-weight: bold;">Funding Segment <b class="text-danger">*</b></p>
        </span>
        <section class="tp-section" style="width: 90%;">
          <mat-form-field appearance="outline">
            <mat-select panelClass="overlay-width-group" placeholder="Please Select Funding Segment" [(ngModel)]="addUcmgDataUpdated.Funding_SegmentID" (selectionChange)="change()">
              <input matInput type="text" [placeholder]="fundingSegmentSearch == '' ? 'Search' : ''" [(ngModel)]="fundingSegmentSearch" (keyup)="searchFundingSegment($event)" class="funding-search" (keydown)="$event.stopPropagation()">
              <mat-option class="dropDownList"  *ngFor="let segmentId of fundingSegment" [value]="segmentId" [disabled]="segmentId == 'No results found'">
                <ng-container>
                    {{segmentId}}
                </ng-container>
            </mat-option>
            </mat-select>
          </mat-form-field>
        </section>
      </div>
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
      <div class="form-group ">
        <span class="opid form-inline" for="groupname">
          <p style="color: #013b71;font-weight: bold;">Year <b class="text-danger">*</b></p>
        </span>
        <section class="tp-section" style="width: 90%;">
          <mat-form-field appearance="outline">
    
            <mat-select panelClass="overlay-width-group" placeholder="Please Select Year"
              [(ngModel)]="addUcmgDataUpdated.year" (selectionChange)="change()">
              <mat-option class="dropDownList" *ngFor="let year of yearList" [value]="year.name">
                <ng-container>
                  {{year.name}}
                </ng-container>
              </mat-option>
            </mat-select>
          </mat-form-field>
    
        </section>
      </div>
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
      <div class="form-group ">
        <span class="opid form-inline" for="groupname">
          <p style="color: #013b71;font-weight: bold;">Investment Status <b class="text-danger">*</b></p>
        </span>
        <section class="tp-section" style="width: 90%;">
          <mat-form-field appearance="outline">
            <mat-select panelClass="overlay-width-group" placeholder="Please Select Investment Status"
              [(ngModel)]="addUcmgDataUpdated.investmentStatus" (selectionChange)="change()">
              <mat-option class="dropDownList" *ngFor="let status of investmentStatus" [value]="status.name">
                <ng-container>
                  {{status.name}}
                </ng-container>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </section>
      </div>
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name" (ngModelChange)="onInputChange()" >
      <span class="form-inline-new">
        <p class="lob-headers">UCMG ID <b class="text-danger">*</b></p>
      </span>
      <input Placeholder="Enter UCMG ID" class="lob-add-input lob-border" [(ngModel)]="addUcmgDataUpdated.UCMG_ID"  pattern="[0-9]*" 
      (keypress)="onlyNumberKey($event, 'ucmgId')" (paste)="onlyNumberKey($event, 'ucmgId')" maxlength="30">
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name" (ngModelChange)="onInputChange()">
      <span class="form-inline-new">
        <p class="lob-headers">UCMG Name <b class="text-danger">*</b></p>
      </span>
      <input Placeholder="Enter UCMG Name" class="lob-add-input lob-border" [(ngModel)]="addUcmgDataUpdated.UCMG_Name">
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
      <span class="form-inline-new">
        <p class="lob-headers">Total Forecast <b class="text-danger">*</b></p>
      </span>
      $ 
      <input  class="lob-add-input lob-border" [(ngModel)]="addUcmgDataUpdated.acap" (ngModelChange)="onInputChange()" appIntegerOnly [allowNegative]=true>
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
      <span class="form-inline-new">
        <p class="lob-headers">Optum Tech Labor <b class="text-danger">*</b></p>
      </span>
      $ 
      <input class="lob-add-input lob-border" [(ngModel)]="addUcmgDataUpdated.optumTechLabour" (ngModelChange)="onInputChange()" appIntegerOnly [allowNegative]=allowNegative [ngClass]="{'input-error': ValidateInput('optumTechLabour')}">
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
      <span class="form-inline-new">
        <p class="lob-headers">Advisory Services <b class="text-danger">*</b></p>
      </span>
      $ 
      <input  class="lob-add-input lob-border" [(ngModel)]="addUcmgDataUpdated.advisoryService" (ngModelChange)="onInputChange()" appIntegerOnly [allowNegative]=allowNegative [ngClass]="{'input-error': ValidateInput('advisoryService')}">
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-3">
      <span class="form-inline-new">
        <p class="lob-headers">Business Labor <b class="text-danger">*</b></p>
      </span>
      $ 
      <input  class="lob-add-input lob-border" [(ngModel)]="addUcmgDataUpdated.bussinessLabour" (ngModelChange)="onInputChange()"  appIntegerOnly [allowNegative]=allowNegative [ngClass]="{'input-error': ValidateInput('bussinessLabour')}">
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-3">
      <span class="form-inline-new">
        <p class="lob-headers">Hardware/Software <b class="text-danger">*</b></p>
      </span>
      $ 
      <input class="lob-add-input lob-border" [(ngModel)]="addUcmgDataUpdated.hardware_software" (ngModelChange)="onInputChange()" appIntegerOnly [allowNegative]=allowNegative [ngClass]="{'input-error': ValidateInput('hardware_software')}">
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-3">
      <span class="form-inline-new">
        <p class="lob-headers">Other Chargebacks <b class="text-danger">*</b></p>
      </span>
      $ 
      <input class="lob-add-input lob-border" [(ngModel)]="addUcmgDataUpdated.other_chargebacks" (ngModelChange)="onInputChange()"appIntegerOnly [allowNegative]=allowNegative [ngClass]="{'input-error': ValidateInput('other_chargebacks')}">
    </div>
    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-3">
      <span class="form-inline-new">
        <p class="lob-headers">Professional Fees <b class="text-danger">*</b></p>
      </span>
      $ 
      <input class="lob-add-input lob-border" [(ngModel)]="addUcmgDataUpdated.professional_fees" (ngModelChange)="onInputChange()" appIntegerOnly [allowNegative]=allowNegative [ngClass]="{'input-error':ValidateInput('professional_fees')}">
    </div>

    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-3">
      <span class="form-inline-new">
        <p class="lob-headers">Portfolio Manager 
        </p>
      </span>
      
            <div class="lob-chip-field lob-border">
                <ng-container class="example-chip-list">
                    <mat-form-field (click)="focusOnInput('inputAddPortfolioManager')" *ngIf="AddOwner.Portfolio_Manager" class="inline-form-edit lob-names-chip chip-fields" floatLabel="never">
                        <!-- show selected person -->
                        <mat-chip-grid #chipListdel>
                            <mat-chip-row class="stk-mat-chip" *ngFor="let owner of AddOwner.Portfolio_Manager"
                                (removed)="removeOwners(owner, 'Portfolio_Manager')">
                                <span title="{{owner.MSId}}" style="cursor: pointer;">
                                    {{owner.displayName}}
                                </span>
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                        </mat-chip-grid>
                        <!-- Type for person to search -->
                        <input #inputAddPortfolioManager class="lob-chip-input" placeholder="Search by Name/Mail" [matAutocomplete]="auto"
                            (keyup)="keyUpSearch($event, 'Portfolio_Manager')" [matChipInputFor]="chipListdel"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
                            [disabled]="AddOwner.Portfolio_Manager.length === 1" [ngClass]="{'input-disabled': AddOwner.Portfolio_Manager.length === 1}">
                        <!-- Selection Options -->
                        <mat-autocomplete showPanel=true class="lob-options-list" #auto="matAutocomplete"
                            (optionSelected)="AddOwnerRole($event, 'Portfolio_Manager')">
                            <mat-option *ngFor="let user of LDAPusersPM" [disabled]="checkExistUser(user, 'Portfolio_Manager', 'Add')"  
                                title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})" [value]="user">
                                {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </ng-container>
            </div>
    </div>

    <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-3">
      <span class="form-inline-new">
        <p class="lob-headers">UCMG Owner 
      </span>
      
            <div class="lob-chip-field lob-border">
                <ng-container class="example-chip-list">
                    <mat-form-field (click)="focusOnInput('inputAddUCMGOwner')" *ngIf="AddOwner.UCMG_Owner" class="inline-form-edit lob-names-chip chip-fields" floatLabel="never">
                        <mat-chip-grid #chipListdel>
                            <mat-chip-row class="stk-mat-chip" *ngFor="let owner of AddOwner.UCMG_Owner"
                                (removed)="removeOwners(owner, 'UCMG_Owner')">
                                <span title="{{owner.MSId}}" style="cursor: pointer;">
                                    {{owner.displayName}}
                                </span>
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                        </mat-chip-grid>
                        <input #inputAddUCMGOwner class="lob-chip-input" placeholder="Search by Name/Mail" [matAutocomplete]="auto"
                            (keyup)="keyUpSearch($event, 'UCMG_Owner')" [matChipInputFor]="chipListdel"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
                            [disabled]="AddOwner.UCMG_Owner.length === 1" [ngClass]="{'input-disabled': AddOwner.UCMG_Owner.length === 1}">
                        <mat-autocomplete showPanel=true class="lob-options-list" #auto="matAutocomplete"
                            (optionSelected)="AddOwnerRole($event, 'UCMG_Owner')">
                            <mat-option *ngFor="let user of LDAPusersUCMG" [disabled]="checkExistUser(user, 'UCMG_Owner', 'Add')"  
                                title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})" [value]="user">
                                {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </ng-container>
            </div>
    </div>

  </div>
  <div class="pull-right lob-add-apply-margin">
    <button mat-mdc-raised-button [disabled]="disableApplyBtn()" (click)="applyAddLeader()" class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size">
        Apply
    </button>
</div> 